<template lang="pug">
GreyPage
  .full-width
    .page-header.mb-XL
      h1.h1(v-if="booking.Key")
        | Edit booking
        span.booking-number ({{booking.Number}})
      h1(v-else) New booking
      slot

    .grid
      .left-column
        PanelBookingDetails(:booking="booking" :classifications="classifications")
        PanelCustomer(v-if="!booking.Key" :booking="booking")

      .right-column
        PanelScheduledProducts(
          :booking="booking"
          :products="products"
          :resources="resources"
          :classifications="classifications"
          @delete="p => $emit('delete', p)"
          @deleteDeal="p => $emit('deleteDeal', p)"
          )
        PanelNonScheduledProducts(
          :booking="booking"
          :products="products"
          :classifications="classifications"
          @delete="p => $emit('delete', p)"
          @switchNonScheduledProduct="x => $emit('switchNonScheduledProduct', x)"
          )

    .page-actions
      slot(:index="2")
</template>

<script>
import PanelCustomer from './UpsertBooking/PanelCustomer.vue'
import PanelBookingDetails from './UpsertBooking/PanelBookingDetails.vue'
import PanelScheduledProducts from './UpsertBooking/PanelScheduledProducts.vue'
import PanelNonScheduledProducts from './UpsertBooking/PanelNonScheduledProducts.vue'

export default {
  name: 'UpsertBooking',
  components: {
    PanelCustomer,
    PanelBookingDetails,
    PanelScheduledProducts,
    PanelNonScheduledProducts,
  },
  props: {
    booking: { type: Object, required: true },
    products: { type: Array, required: true },
    resources: { type: Object, required: true },
    classifications: { type: Array, required: true },
  },
}
</script>

<style scoped lang="stylus">
.full-width
  width 100%
  text-align left

.page-header
  display flex
  justify-content space-between
  align-items center

.products h2
  margin-bottom 0

.grid
  display grid
  grid-template-columns 1fr 3fr
  gap 0 30px

.page-actions
  display flex
  justify-content center

.booking-number
  font-weight 300
</style>
